import { Menubar } from '../../../areas/Menubar/Menubar';
import { MenubarSpeak } from '../../../areas/Menubar/Attention/Speak/MenubarSpeak';
import { MenubarHear } from '../../../areas/Menubar/Attention/Hear/MenubarHear';
import { MenubarPath } from '../../../areas/Menubar/Path/MenubarPath';
import { MenubarProgress } from '../../../areas/Menubar/Progress/MenubarProgress';
import { MenubarRight } from '../../../areas/Menubar/Right/MenubarRight';
import { MenubarUseronline } from '../../../areas/Menubar/Right/UserOnline/MenubarUseronline';
export class LargeClasses {
    Menubar = Menubar;
    MenubarSpeak = MenubarSpeak;
    MenubarHear = MenubarHear;
    MenubarPath = MenubarPath;
    MenubarProgress = MenubarProgress;
    MenubarRight = MenubarRight;
    MenubarUseronline = MenubarUseronline;
}
